<template>
<div class="d-flex flex-column sticky-footer-wrapper">
    <main class="flex-fill">
      <app-header></app-header>
      <message-component></message-component>
      <div class="container mt-3">
          <div class="row">
            <div class="col-md-12" style="margin-top: 95px">
              <router-view></router-view>
            </div>
          </div>
      </div>
    </main>

    <footer class="navbar-default navbar-bottom navbar-dark bg-dark">
      <div class="container-fluid">
            <!-- <p class="text-center nav-bar mb-0">
              <a href="https://www.signledger.com" target="_blank">
                SignLedger
              </a>
            </p> -->
            <div class="text-center">
              <a href="https://www.signledger.com" target="_blank">SignLedger LLC</a>
              <span class="ml-1">&copy; {{new Date().getFullYear()}} </span>
            </div>
            <!-- <p class="text-center nav-bar mb-0">Checkout repository at <a href="https://github.com/ittus/vuejs-firebase-shopping-cart" target="_blank">
              https://github.com/ittus/vuejs-firebase-shopping-cart
            </a></p> -->
      </div>
    </footer>
</div>

</template>

<script>
  import { mapActions } from 'vuex';
  import Header from './components/Header.vue';
  import MessageComponent from './components/common/MessageComponent.vue';

  export default {
    components: {
      appHeader: Header,
      MessageComponent
    },

    created() {
      //let uid = this.$store.getters.currentUser.uid;
      let orgId = this.$route.params.orgId;
      let location = this.$route.params.location;

      if(!orgId || !location){
        this.$router.push('/pages/about')
        return
      }

      if (orgId.toLowerCase()=="ketco")
        orgId = "1"

      this.listenToProductList({orgId, location})

    },

    methods: {
      ...mapActions(['authStatusChange', 'listenToProductList', 'getShoppingCart']),
    }

  }
</script>

<style>
  #reset-store-panel {
    position: fixed; bottom: 0px; right: 0px;
  }

  body, .sticky-footer-wrapper {
     min-height:100vh;
  }

  .flex-fill {
     flex:1 1 auto;
  }
  footer {
    height: 40px;
    color: #666;
    padding: 10px 0 10px 0;
    font-size: 85%;
  }
  footer a {
    color: #999;
  }
  footer a:hover {
    color: #efefef;
  }
  @media (max-width: 576px) {
    footer {
      height: 50px;
    }
  }
</style>
